import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_BASE = API;

// V27 — Super Mode session token (held in sessionStorage so it never persists
// across browser sessions / new logins, per the security spec).
export const SUPER_MODE_STORAGE_KEY = "at_super_mode_token";
export function getSuperModeToken() {
    try { return sessionStorage.getItem(SUPER_MODE_STORAGE_KEY) || ""; } catch { return ""; }
}
export function setSuperModeToken(token) {
    try {
        if (token) sessionStorage.setItem(SUPER_MODE_STORAGE_KEY, token);
        else sessionStorage.removeItem(SUPER_MODE_STORAGE_KEY);
    } catch { /* sessionStorage unavailable — ignore */ }
}
export function clearSuperModeToken() { setSuperModeToken(""); }

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("at_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const sm = getSuperModeToken();
    if (sm) config.headers["X-Super-Mode-Token"] = sm;
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
    if (detail?.msg) return detail.msg;
    return String(detail);
}
